import { Outlet, Navigate } from "react-router-dom";
import { LoginTimeStamp } from "../utilFunctions/LoginTimeStamp";

const PrivateRoute = () => {
  const loggedIn = LoginTimeStamp();
  return loggedIn ? <Outlet /> : <Navigate to="/login" />;
};
export default PrivateRoute;
